<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col cols="12" md="10">
        <v-card>
          <v-card-title>
            <v-img :src="logos"></v-img>
          </v-card-title>
          <ValidationObserver ref="uno" v-slot="{ handleSubmit, invalid }">
            <v-form style="padding: 3%;" @submit.prevent="handleSubmit(save)" class="mt-n5">
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-radio-group color="primary" row v-model="languaje" mandatory>
                      <v-radio color="primary" label="(Es) Español" :value="false"/>
                      <v-radio color="primary" label="(En) English" :value="true"/>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row class="mt-n5">
                  <v-col cols="12" md="12">
                    <span>{{languaje?'ID':'Tipo de documento'}}</span>
                    <v-radio-group row v-model="forms.documentType" mandatory>
                      <v-radio value="Cédula de Ciudadanía" :label="languaje?'Social Security Number':'Cédula de Ciudadanía'"></v-radio>
                      <v-radio value="Cédula de Extranjeria" :label="languaje?'Foreigner':'Cédula de Extranjeria'"></v-radio>
                      <v-radio value="Pasaporte" :label="languaje?'Passport':'Pasaporte'"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row class="mt-n5">
                  <v-col cols="12" md="6">
                    <ValidationProvider v-slot="{ errors }" name="ID Number/N° Documento" rules="required">
                      <v-text-field :error-messages="errors" :label="languaje?'ID Number':'N° Documento'" rounded filled dense v-model="forms.document"/>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="Name/Nombres" rules="required">
                      <v-text-field :error-messages="errors" :label="languaje?'Name':'Nombres'" rounded filled dense class="mt-n2" v-model="forms.name"/>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="Last Name/Apellidos" rules="required">
                      <v-text-field :error-messages="errors" :label="languaje?'Last Name':'Apellidos'" rounded filled dense class="mt-n2" v-model="forms.lastname"/>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="E-mail/Correo Electrónico" rules="required">
                      <v-text-field :error-messages="errors" type="email" :label="languaje?'E-mail':'Correo Electrónico'" filled rounded dense class="mt-n2" v-model="forms.email"/>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="Cellphone Number/Celular" rules="required">
                      <v-text-field :error-messages="errors" :label="languaje?'Cellphone Number':'Teléfono/Celular'" type="number" filled rounded dense v-model="forms.phone"/>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12" md="6" >
                    <ValidationProvider v-slot="{ errors }" name="Country/País de residencia" rules="required">
                      <v-autocomplete :error-messages="errors" :items="countrys" v-model="forms.country" :loading="countring" :label="languaje?'Country':'País de residencia'" dense filled rounded/>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="City/Ciudad de residencia" rules="required">
                      <v-text-field :error-messages="errors" :label="languaje?'City':'Ciudad de residencia'" filled rounded dense v-model="forms.cityPerson" class="mt-n2"/>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="Address/Dirección" rules="required">
                      <v-text-field :error-messages="errors" :label="languaje?'Address':'Dirección'" filled rounded dense v-model="forms.address" class="mt-n2"/>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="Company/Empresa" rules="required">
                      <v-text-field :error-messages="errors" :label="languaje?'Company':'Empresa'" filled rounded dense v-model="forms.company" class="mt-n2"/>
                    </ValidationProvider>
                    <ValidationProvider v-slot="{ errors }" name="Job/Cargo" rules="required">
                      <v-text-field :error-messages="errors" :label="languaje?'Job':'Cargo'" filled rounded dense v-model="forms.job" class="mt-n2"/>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" rounded :loading="saving" type="submit" :disabled="invalid">{{languaje?'Save':'Guardar'}}</v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {db, marcadetiempo} from "../firebase";
import emailjs from "@emailjs/browser";
extend("required", { ...required, message: "{_field_} no puede estar vacío"});
export default {
  components:{ ValidationObserver, ValidationProvider},
  name: "Registro",
  data:()=>({
    languaje:false,
    forms:{
      documentType:null,
      document:null,
      name:null,
      lastname:null,
      email:null,
      phone:null,
      country:null,
      cityPerson:null,
      address:null,
      company:null,
      job:null,
      createdAt:marcadetiempo(),
      confirmed:false,
      countFirst:0,
      languaje:null,
      dates:null
    },
    countring:false,
    countrys:[],
    saving:false,
    logos: require('../../public/BANERREGISTRO.jpg')
  }),
  methods:{
    fetchCountry(){
      this.countring=true
      this.$http.get('https://restcountries.com/v3.1/all').then(res=>{
        let arreglo = res.data.map(x=>x.name.common)
        this.countrys = arreglo.sort()
        //console.log()
      }).finally(()=>{
        this.countring=false
      })
    },
    async save(){
      this.forms.dates = new Date().toString()
      this.saving=true
      this.forms.languaje= this.languaje
      await db.collection("ocimf").doc(this.forms.email.toString()).set(this.forms).then((e)=> {
        this.sendEmail(this.forms)

        }).catch(err => {
          this.$toast.error("Error, Intentelo más tarde")
        }).finally(() => {
          this.forms = {
            documentType: "Cédula de Ciudadanía",
            document: null,
            name: null,
            lastname: null,
            email: null,
            phone: null,
            country: null,
            cityPerson: null,
            address: null,
            company: null,
            job: null,
            createdAt: marcadetiempo(),
            confirmed: false,
            countFirst: 0
          }
          requestAnimationFrame(() => {
            this.$refs.uno.reset();
          });
          this.saving = false

        })


    },
    sendEmail(item){

      let template = 'template_i0jo8ju'
      let datos= {
        to_name:`${item.name} ${item.lastname}`,
        to_email:item.email,
      }

      emailjs.send('service_1pb9hzp','template_xfp0edl', datos, 'vCSlIQ7JrOnXGRV5C').then(e => {
            if (e.status == 200) {
              this.$toast.success(`Le enviamos la confirmación a: ${item.email}`)
            } else {
              this.$toast.error('No logramos enviar el correo')
            }
      })

    }
  },
  created() {
    this.fetchCountry()
  }
}
</script>

<style scoped>

</style>